import React from 'react';

export default function PrivacyProviders(props: React.PropsWithChildren) {
  return <>{props.children}</>;
}
